// localStorage can be disabled sometimes - https://michalzalecki.com/why-using-localStorage-directly-is-a-bad-idea/
// will fallback to simple in-memory object
const data = {};

export default {
  setItem: (key: string, value: string): void => {
    data[key] = value;
  },
  getItem: (key: string): string | undefined | null => data[key],
  removeItem: (key: string): void => {
    delete data[key];
  }
};
